import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/services';

const get = async (
	params?: Services.GetServicesListParams,
): Promise<Array<Services.Service>> => {
	const queryParams = createQueryParams({
		active: params?.active,
		type: params?.type,
	});
	const qs = queryParams.toString();
	const url = qs ? `${DOMAIN}?${qs}` : DOMAIN;
	const { data } = await api.get(url);
	return data;
};

/** Tabela pública de repasse ao profissional (valor único por serviço). */
const getRepasseTable = async (): Promise<Array<Services.RepasseItem>> => {
	const { data } = await api.get(`${DOMAIN}/repasse-table`);
	return data;
};

const getByServiceName = async (service_name: string) => {
	const { data } = await api.get(`${DOMAIN}/by-service-name/${service_name}`);
	return data;
};

const getById = async (id: string): Promise<Services.Service> => {
	const { data } = await api.get(`${DOMAIN}/${id}`);
	return data;
};

const patch = async (
	id: string,
	body: Partial<Services.Create>,
): Promise<Services.Service> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);

	return data;
};

const remove = async (id: string): Promise<void> => {
	await api.delete(`${DOMAIN}/${id}`);
};

const post = async (body: Services.Create): Promise<Services.Service> => {
	const { data } = await api.post(DOMAIN, body);
	return data;
};

const toggleStatus = async (
	id: string,
	active: boolean,
): Promise<Services.Service> => {
	const { data } = await api.patch(`${DOMAIN}/${id}/status`, { active });
	return data;
};

/** Reordena a exibição dos serviços para o usuário (agendamento/home). */
const reorderDisplay = async (
	body: Services.ReorderDisplay,
): Promise<Array<Services.Service>> => {
	const { data } = await api.put(`${DOMAIN}/display-order`, body);
	return data;
};

const ServiceService = {
	get,
	reorderDisplay,
	getById,
	getRepasseTable,
	patch,
	remove,
	getByServiceName,
	post,
	toggleStatus,
};

export { ServiceService };
